import { Component, OnInit, OnDestroy } from '@angular/core';

import { MyBookingsService } from '../../core/services/my-bookings.service';
import { Observable, Subscription } from 'rxjs';
import { List } from '../../core/models/list.model';
import { User } from '../../core/models/user.model';
import { PPAuthService } from '../../core/services/auth.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-my-bookings',
  templateUrl: './my-bookings.page.html',
  styleUrls: ['./my-bookings.page.scss'],
})
export class MyBookingsPage {

  activeBookings$: Observable<List>;
  archiveBookings$: Observable<List>;
  me2Subscribtion: Subscription;

  constructor( private authService: PPAuthService, private myBookingsService: MyBookingsService , private translateService: TranslateService ) {
  }

  ionViewWillEnter() {
    this.me2Subscribtion = this.authService.me2$.subscribe( user => {
        if ( user ) {
          this.activeBookings$ = this.myBookingsService.getActiveBookings$( user.id );
          this.archiveBookings$ = this.myBookingsService.getArchiveBookings$( user.id );
        }
      }
    );
  }


  ionViewWillLeave() {
    this.me2Subscribtion.unsubscribe();
  }


}
